import { MobileLayout } from 'components/mobile/MobileLayout/MobileLayout';
import { Layout } from 'components/Layout/Layout';
import styles from '../styles/pages/LanguageSelection.module.css';
import { useBreakpoint } from 'hooks/useBreakpoint';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getLocales } from 'services/localesService';
import { useState } from 'react';
import classNames from 'classnames';
import { appLanguageOf } from 'config/languages';

export const LanguageSelection = () => {
  const { t, i18n } = useTranslation();
  const { isMobile } = useBreakpoint();
  const navigate = useNavigate();
  // i18next may hold "sr-RS": the list's codes are two letters.
  const [selectedLanguage, setSelectedLanguage] = useState(
    appLanguageOf(i18n.language)
  );
  const locales = getLocales();

  const picker = (
    <div className={styles.wrapper}>
      {locales.map((lang) => (
        <div
          className={classNames(
            styles.languageOption,
            selectedLanguage === lang.code ? styles.selectedLanguage : ''
          )}
          key={lang.code}
          onClick={() => setSelectedLanguage(appLanguageOf(lang.code))}
        >
          <img src={`/photos/icons/${lang.code}.png`} alt="Language" />
          <span className="sans-serif-design">{lang.fullName}</span>
        </div>
      ))}
      <div className={styles.buttonWrapper}>
        <button
          className="sans-serif-design"
          onClick={(e) => {
            e.preventDefault();
            i18n.changeLanguage(selectedLanguage);
            localStorage.setItem('lang', selectedLanguage);
            navigate('/');
          }}
        >
          {t('change_language_label')}
          {isMobile && <div className="checkmark mobile-css-icons"></div>}
        </button>
      </div>
    </div>
  );

  // The account menu links here on desktop too (modern layout).
  if (!isMobile) {
    return (
      <Layout>
        <div className={styles.desktop}>
          <p className={styles.desktopTitle}>{t('language_selection_label')}</p>
          {picker}
        </div>
      </Layout>
    );
  }

  return (
    <MobileLayout title={t('language_selection_label')}>{picker}</MobileLayout>
  );
};
